import { IFilter, IFilterOperator } from "./filter.interface";

export abstract class FilterFactory {
  field?: IFilterField;
  operators?: IFilterOperator[];
  criterias?: ICriteria[];

  selectedOperator?: IFilterOperator;
  selectedCriteria?: ICriteria[] | string;

  abstract build(): IFilter;

  createFilterStructure(query: string): IFilter {
    return {
      field: this.field!.label,
      operator: this.selectedOperator!.label,
      criteria: Array.isArray(this.selectedCriteria)
        ? this.selectedCriteria.map(criteria => criteria.label).join(", ")
        : this.selectedCriteria!.toString(),
      query
    }
  };
}

export interface ICriteria {
  label: string;
  value: string;
}

export interface IFilterField {
  label: string;
  queryValue: string;
}
